export const DEFAULT_STALE_TIME = 30000;
